let deferred = null;
const listeners = new Set();
const notify = () => listeners.forEach((f) => f());

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const canPrompt = () => !!deferred;
export const onPwaChange = (f) => { listeners.add(f); return () => listeners.delete(f); };

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  notify();
  return outcome === "accepted";
}

const bundleOf = (html) => (html.match(/\/static\/js\/main\.[a-z0-9]+\.js/) || [])[0];

async function reloadIfNewBuild() {
  const cur = bundleOf(document.documentElement.innerHTML);
  if (!cur) return;
  try {
    const html = await (await fetch("/", { cache: "no-store" })).text();
    const next = bundleOf(html);
    if (next && next !== cur) window.location.reload();
  } catch {}
}

export function registerPwa() {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; notify(); });
  window.addEventListener("appinstalled", () => { deferred = null; notify(); });
  if (!("serviceWorker" in navigator) || process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      const check = () => reg.update().catch(() => {});
      setInterval(check, 5 * 60 * 1000);
      document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { check(); reloadIfNewBuild(); } });
      setInterval(reloadIfNewBuild, 10 * 60 * 1000);
    }).catch(() => {});
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded || !navigator.serviceWorker.controller) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
